import _mFooter from "./../../levels/desktop.blocks/m-footer/m-footer.react.js";

var MFooter = _mFooter.applyDecls();

import "./../../levels/desktop.blocks/m-footer/m-footer.css";


export default MFooter;